import type { Option } from "../labels";

// The suggestions of the time zone field (a `<datalist>`; the field takes any valid IANA name). The list
// comes from the browser's own `Intl` data. That data lists the engine's canonical names, which can differ
// from the name a staff member types (an engine may say `Asia/Calcutta` for `Asia/Kolkata`), so the field
// is not limited to the list. The zone Lafayette's city table suggests for the item is marked, never
// chosen for the staff member. No provider zone is ever a suggestion or a default here.

function knownZones(): readonly string[] {
  return typeof Intl.supportedValuesOf === "function" ? Intl.supportedValuesOf("timeZone") : [];
}

export function timeZoneOptions(current: string, suggested: string | null): readonly Option[] {
  const zones = new Set<string>(["UTC", ...knownZones()]);
  if (current !== "") zones.add(current);
  if (suggested !== null) zones.add(suggested);
  return [...zones]
    .sort((a, b) => a.localeCompare(b))
    .map((zone) => ({ value: zone, label: zone === suggested ? `${zone} (suggested)` : zone }));
}
